
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sexleketoy/dildo",
      function () {
        return require("private-next-pages/sexleketoy/dildo/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sexleketoy/dildo"])
      });
    }
  